// extracted by mini-css-extract-plugin
export default {"container":"EventPage_container__cu6Yd","showAllSessionsButton":"EventPage_showAllSessionsButton__aTCbg","isNotEnglish":"EventPage_isNotEnglish__ktPDr"};